import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-card" data-id="element-79" data-mp="1hbgtc9p1fr26">
      <div className="max-w-3xl mx-auto" data-id="element-80" data-mp="1cf9lucgzu7i4">
        <div className="text-center mb-16" data-id="element-81" data-mp="1cgb5h5c2s2bg">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-82" data-mp="2a2s2e9gwcdwo">
            ❓ Domande frequenti
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83" data-mp="254gtq22c89g1">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="bg-black border border-dark-border rounded-xl overflow-hidden" data-id="element-84" data-mp="1v4zotmuwtzl4" data-mpi={index}>
                <h3 data-id="element-85" data-mp="opp41wwktgaf">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} id={`faq-button-${index}`} className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-light focus-visible:ring-inset" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-86" data-mp="omt1fv9sa3fn">
                    <span className="font-bold text-lg text-white font-serif" data-id="element-87" data-mp="1fqqap1kk658o">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`text-gold transition-transform duration-200 ease-out shrink-0 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-88" data-mp="16oh3oloi0u01" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-89" data-mp="izfq6k0t6snw">
                  {isOpen && <motion.div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-button-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-90" data-mp="n07ztedlezkp">
                      <p className="px-6 pb-5 text-gray-300 border-t border-dark-border pt-4" data-id="element-91" data-mp="38lr78mhm0riu">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}